module.exports = __webpack_public_path__ + "static/media/aa.752326a8.png";